@import "../../scss";

.root {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;
  text-align: center;
  flex-shrink: 0;
  width: 100%;

  @include media-breakpoint-down("md") {
    justify-content: flex-start;
    align-items: stretch;
    flex-direction: row;
    height: 100%;
    flex-shrink: 0;
    width: 85%;
    margin-right: var(--spacer-3);
  }
}

.root:not(:last-child) {
  margin-bottom: var(--spacer-7);

  @include media-breakpoint-down("md") {
    margin-bottom: 0;
  }
}

.root picture {
  width: 100%;
  @include media-breakpoint-down("md") {
    flex-shrink: 0;
    display: contents;
  }
}

.image {
  width: 100%;
  height: auto;
  border-radius: 1.25rem;
  margin-bottom: var(--spacer-3);
  object-fit: contain;

  @media (min-aspect-ratio: "15/8") {
    width: 78%;
    margin-left: auto;
    margin-right: auto;
  }

  @include media-breakpoint-down("md") {
    max-height: unset;
    border-radius: 0.75rem;
    height: 100%;
    width: auto;
    flex-shrink: 0;
    margin-right: var(--spacer-2);
    margin-bottom: 0;
  }
}

.name {
  color: var(--color-bright-green);
  @include typo--look-viewer-item-name;
  margin-bottom: var(--spacer-3);
}

.sold-out {
  color: var(--color-bright-green);
  @include typo--button;
  margin-bottom: var(--spacer-1);
}

.text {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  flex-shrink: 0;

  @include media-breakpoint-down("md") {
    flex-shrink: 1;
    align-items: flex-start;
    justify-content: space-between;
    text-align: left;
    overflow: visible;
    white-space: pre-line;
  }
}

.button:before {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  content: "";
}
